import React, { useEffect, useRef } from 'react';
import { Box, Button, Collapse, Dialog, DialogActions, DialogTitle, Divider } from '@material-ui/core';
import { DragArea } from '@sierralabs/core-ui';
import FileUploadList from '../components/FileUploadList';
import { useFileUploadManager } from '../hooks/useFileUploadManager';
import { useFileUploader } from '../hooks/useFileUploader';
const FileUploadDialog = (props) => {
    const { open, folder, inputType, referenceTaskId, fileMultiInputRef: fileMultiInputRefProp, setOpen, onDismiss, renderContent } = props;
    const fileMultiInputRef = useRef(null);
    const cancelCallbackRef = useRef();
    const uploader = useFileUploader();
    const manager = useFileUploadManager({ unique: false });
    const dismiss = () => {
        var _a;
        (_a = cancelCallbackRef.current) === null || _a === void 0 ? void 0 : _a.call(cancelCallbackRef);
        setOpen(false);
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(manager.progress);
    };
    const handleFiles = (newFiles) => {
        if (newFiles && newFiles.length > 0) {
            // append new files
            manager.add(Array.from(newFiles));
        }
    };
    // clear state
    useEffect(() => {
        !open && manager.clear();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { hidden: true, multiple: true, type: 'file', accept: inputType, ref: ref => {
                fileMultiInputRef.current = ref;
                if (fileMultiInputRefProp) {
                    fileMultiInputRefProp.current = ref;
                }
            }, onChange: event => {
                handleFiles(event.target.files);
                // clear value
                if (fileMultiInputRef.current) {
                    fileMultiInputRef.current.value = '';
                }
            } }),
        React.createElement(Dialog, { fullWidth: true, maxWidth: 'sm', open: open, onClose: dismiss },
            React.createElement(DialogTitle, null, "Upload Files"), renderContent === null || renderContent === void 0 ? void 0 :
            renderContent(manager),
            React.createElement(Box, { mx: 3 },
                React.createElement(DragArea, { onUpload: handleFiles, onClick: () => { var _a; return (_a = fileMultiInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } })),
            React.createElement(Collapse, { in: manager.items.length > 0, style: { minHeight: 'unset' } },
                React.createElement(Box, { mt: 2 },
                    React.createElement(Box, { mb: 2 },
                        React.createElement(Divider, null)),
                    React.createElement(FileUploadList, { folder: folder, manager: manager, uploader: uploader, referenceTaskId: referenceTaskId, renderActions: ({ progress, uploadAllButton, cancelAll }) => {
                            cancelCallbackRef.current = cancelAll;
                            return (React.createElement(DialogActions, null,
                                React.createElement(Button, { variant: 'outlined', onClick: dismiss, disabled: progress.uploading > 0 }, "Dismiss"),
                                uploadAllButton));
                        } }))),
            manager.items.length === 0 && (React.createElement(DialogActions, null,
                React.createElement(Button, { variant: 'outlined', onClick: dismiss }, "Dismiss"))))));
};
export default FileUploadDialog;
//# sourceMappingURL=FileUploadDialog.js.map